import React from 'react'
import {DatePicker as MuiDatePicker} from "@material-ui/pickers";
import {formatDateOnly, parseDateOnly} from "../../../services/datetime/dateOnly";

export default function DatePicker(props) {

  const {
    name,
    label,
    value,
    onChange,
    error = null,
    format = "dd.MM.yyyy",
    minDate,
    maxDate,
    ...rest
  } = props

  const convertToDefEventPara = (name, value) => ({
    target: {
      name, value
    }
  })

  return (
    <MuiDatePicker
      {...rest}
      inputVariant="outlined"
      format={format}
      label={label}
      name={name}
      value={parseDateOnly(value)}
      onChange={date => onChange(convertToDefEventPara(name, date ? formatDateOnly(date) : null))}
      minDate={minDate != null ? parseDateOnly(minDate) ?? undefined : undefined}
      maxDate={maxDate != null ? parseDateOnly(maxDate) ?? undefined : undefined}
      error={!!error}
      helperText={error}
      cancelLabel={"Отмена"}
      okLabel={"Подтвердить"}
    />
  )
}
